import { Page } from "components/Page";
import { useEffect, useState } from "react";

import "react-tabulator/css/bootstrap/tabulator_bootstrap.min.css";
import "react-tabulator/lib/styles.css";

import { Outlet, useRouteLoaderData } from "react-router-dom";
import { AliErrorRecord } from "services/ALIErrorRecord";
import { formatPhoneNumber } from "utils/helpers";

const ALIErrorRecordsView = () => {
  const viewData: AliErrorRecord | any = useRouteLoaderData("view_idx");
  const editData: AliErrorRecord | any = useRouteLoaderData("edit_idx");
  const deleteData: AliErrorRecord | any = useRouteLoaderData("delete_idx");
  const [phone, setPhone] = useState<string>("");

  useEffect(() => {
    if (viewData !== undefined) {
      setPhone(formatPhoneNumber(viewData.CPN));
    } else if (editData !== undefined) {
      setPhone(formatPhoneNumber(editData.CPN));
    } else if (deleteData !== undefined) {
      setPhone(formatPhoneNumber(deleteData.CPN));
    } else {
      setPhone("");
    }
  }, [viewData, editData, deleteData]);

  return (
    <Page
      title={phone}
      parentRoute="/ali-errors"
      label="ALI Errors"
      breadCrumb={{ id: "cpn", title: phone, active: phone ? true : undefined }}
    >
      <Outlet />
    </Page>
  );
};

export default ALIErrorRecordsView;
